import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Fab, Tooltip } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import styled from 'styled-components';
import Note from '../../components/Note';
import TopBar from '../../components/TopBar';
import { withPaymentCheck } from '../../hoc/withPaymentCheck';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  padding: 20px;
`;

const NotesWrapper = styled.div`
  width: 100%;
  max-width: 860px;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
`;

const NotesHeader = styled.div`
  display: flex;
  justify-content: center;
  border-bottom: 3px solid #757c87;
`;

const Title = styled.h1`
  width: 100%;
  color: #ffffff;
`;

const CreateButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const NotesContainer = styled.div`
  padding-top: 20px;
`;

const EmptyNotesPlaceholder = styled.p`
  color: #ffffff;
  text-align: center;
  font-size: 22px;
`;

@inject('notesStore', 'routerStore', 'userStore')
@observer
class NotesPage extends Component {
  state = {
    paymentPlan: null,
  };

  async componentDidMount() {
    await this.props.notesStore.fetchNotes();
    const paymentPlan = await this.props.notesStore.getPaymentPlan();
    this.setState({ paymentPlan });
  }

  getNoteLimit = () => {
    const { paymentPlan } = this.state;
    if (!paymentPlan) return 0;
    switch (paymentPlan.data) {
      case 'BASIC':
        return 1;
      case 'STANDARD':
        return 5;
      case 'PREMIUM':
        return 25;
      default:
        return 0;
    }
  };

  handleSignOut = () => {
    const { userStore, notesStore } = this.props;
    userStore.signout();
    notesStore.resetNotes();
    window.location.hash = '/signin';
  };

  handlePayment = () => {
    window.location.hash = '/payment';
  };

  renderNotes = () => {
    const { notesStore } = this.props;

    if (!notesStore.notes.length) {
      return <EmptyNotesPlaceholder>No notes available. Create one?</EmptyNotesPlaceholder>;
    }

    return notesStore.notes.map(note => (
      <Note
        key={note.uuid}
        uuid={note.uuid}
        toEmail={note.toEmail}
        toName={note.toName}
        body={note.body}
        status={note.status}
      />
    ));
  };

  render() {
    const { notesStore } = this.props;
    const noteLimit = this.getNoteLimit();
    const noteCount = notesStore.notes.length;
    const canCreateNote = noteCount < noteLimit;

    return (
      <PageContainer>
        <TopBar />
        <NotesWrapper>
          <NotesHeader>
            <Title>Your notes.</Title>

            <CreateButtonContainer>
              <Tooltip title={!canCreateNote ? 'Please upgrade your plan' : ''} placement="top">
                <div>
                  <Fab
                    variant="extended"
                    onClick={() => { window.location.hash = '/notes/create'; }}
                    disabled={!canCreateNote}
                  >
                    <AddIcon />
                    Create Note
                  </Fab>
                </div>
              </Tooltip>
            </CreateButtonContainer>
          </NotesHeader>
          <NotesContainer>
            {this.renderNotes()}
          </NotesContainer>
        </NotesWrapper>
      </PageContainer>
    );
  }
}

export default withPaymentCheck(NotesPage);
